module.exports = __webpack_public_path__ + "media/brands/picking-030fc23e.jpg";